export const mapSickDayDto = (dto) => ({
    id: dto.id,
    userId: dto.user_id,
    startDate: dto.start_date,
    endDate: dto.end_date,
    numberDays: dto.number_days,
    displayName: dto.user_name ?? null,
});
